import './SuggestionGroupLabel.css';
export var suggestionGroupLabel = '_1mfalko0-3-5-0';